const Documents = ({
    t,
    documents,
    documentsUrl,
}) => (
    <div className="overview-esg-rating__side-panel mb-3">
        <p className="overview-esg-rating__eyebrow mb-3">
            {t('ESG & Sustainability Documents')}
        </p>
        {(documents || []).map((document) => (
            <div
                key={document.title}
                className="overview-esg-rating__document"
            >
                <div className="d-flex justify-content-between align-items-start gap-2">
                    <span className="overview-esg-rating__document-title">
                        {document.title}
                    </span>
                    <a
                        href={document.url}
                        target="_blank"
                        rel="noreferrer"
                        className="overview-esg-rating__link flex-shrink-0"
                    >
                        {t('View')} ↗
                    </a>
                </div>
                <span className="overview-esg-rating__document-meta">
                    {t(document.category)}
                </span>
            </div>
        ))}
        {documentsUrl && (
            <div className="text-center pt-2">
                <a
                    href={documentsUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="overview-esg-rating__link"
                >
                    {t('View all documents')} ↗
                </a>
            </div>
        )}
    </div>
);

export default Documents;
